import { useEffect, useRef, useState } from 'react'

interface TooltipProps {
  text: string
  showTooltip: boolean
}

const Tooltip = ({ text, showTooltip }: TooltipProps) => {
  const tooltipRef = useRef<HTMLDivElement>(null)
  const [adjustment, setAdjustment] = useState<'left' | 'right' | 'center'>(
    'center'
  )

  useEffect(() => {
    if (tooltipRef.current) {
      const rect = tooltipRef.current.getBoundingClientRect()
      const padding = 8

      if (rect.left < padding) {
        setAdjustment('left')
      } else if (rect.right > window.innerWidth - padding) {
        setAdjustment('right')
      } else {
        setAdjustment('center')
      }
    }
  }, [showTooltip, text])

  if (!showTooltip || !text) return null

  const positionClass =
    adjustment === 'left'
      ? 'left-0'
      : adjustment === 'right'
        ? 'right-0'
        : 'left-1/2 -translate-x-1/2'

  return (
    <div
      ref={tooltipRef}
      className={`absolute top-[100%] mt-1 px-3 py-2 rounded shadow-lg z-50 bg-white/80 text-imovPrimary text-xs backdrop-blur-sm whitespace-nowrap ${positionClass}`}
    >
      {text}
    </div>
  )
}

export default Tooltip
